export const LINES_STORE_PATH = 'lines/'
